import { sanitizeString } from "./Utils";

export const detectarBandeira = (numero) => {
	if (/^4/.test(numero)) return "VISA";
	if (/^5[1-5]/.test(numero)) return "MASTERCARD";
	if (/^3[47]/.test(numero)) return "AMEX";
	if (/^(636368|438935|504175|451416|636297)/.test(numero)) return "ELO";
	if (/^(606282|3841)/.test(numero)) return "HIPERCARD";
	return "OUTRO";
};

export const BANDEIRA_ICON_MAP = {
	VISA: "visa",
	MASTERCARD: "mastercard",
	ELO: "elo",
	AMEX: "amex",
	HIPERCARD: "hipercard",
};

export const obterTipoIconeBandeira = (bandeira) => {
	return BANDEIRA_ICON_MAP[bandeira] ?? "generic";
};

export const getCardFlag = (value) => {
	let card = value?.replace(/[^0-9]+/g, "");

	let cards = {
		visa: /^4[0-9]{12}(?:[0-9]{3})/,
		mastercard: /^5[1-5][0-9]{14}/,
		diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
		amex: /^3[47][0-9]{13}/,
		discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
		hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
		elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
		jcb: /^(?:2131|1800|35\d{3})\d{11}/,
		aura: /^(5078\d{2})(\d{2})(\d{11})$/,
	};

	for (let flag in cards) {
		if (cards[flag].test(card)) return flag;
	}

	return false;
};

export const validarCartao = (values) => {
	const erros = {};

	if (!values.nome_titular) {
		erros.nome_titular = "Nome do titular é obrigatório.";
	}

	if (!values.cnpj_titular) {
		erros.cnpj_titular = "CNPJ do titular é obrigatório.";
	} else if (sanitizeString(values.cnpj_titular).length !== 14) {
		erros.cnpj_titular = "CNPJ deve conter 14 dígitos.";
	}

	if (!values.numero_cartao) {
		erros.numero_cartao = "Número do cartão é obrigatório.";
	} else {
		const numero_limpo = sanitizeString(values.numero_cartao);
		if (numero_limpo.length < 13 || numero_limpo.length > 19) {
			erros.numero_cartao = "Número do cartão inválido.";
		}
	}

	if (!values.validade) {
		erros.validade = "Validade é obrigatória.";
	}

	if (!values.cvv) {
		erros.cvv = "CVV é obrigatório.";
	}

	return erros;
};
